module.exports = __webpack_public_path__ + "static/media/search.a83a993d.svg";